import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function localTransporters() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`local-transporters/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`local-transporters/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('local-transporters/create', data);
    }

    function update(data) {
        return axiosInstance.patch('local-transporters/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`local-transporters/delete`, {
            data: {
                id: id
            }
        });
    }
}
